export default __webpack_public_path__ + "static/media/Venturer's Gloves of the Yellow Spring.c85a22cb.jpg";